import type { AnyShippingMethod, CustomDeliveryShippingMethod } from "@jti/commerce";

export const isCustomDeliveryMethod = (method: AnyShippingMethod): method is CustomDeliveryShippingMethod => {
  return (
    method.type === "custom delivery" &&
    (method.widgetVariant === "embedded" || method.widgetVariant === "modal") &&
    typeof method.label === "string" &&
    typeof method.methodCode === "string" &&
    typeof method.widgetTagName === "string" &&
    typeof method.widgetUrl === "string"
  );
};

export const findCustomShippingMethod = (
  methods: AnyShippingMethod[] | undefined,
  methodCode: string | undefined
): CustomDeliveryShippingMethod | undefined => {
  if (!methods || !methodCode) return undefined;

  const customShippingMethod = methods.find(
    (method): method is CustomDeliveryShippingMethod =>
      method.methodCode === methodCode && isCustomDeliveryMethod(method)
  );

  return customShippingMethod;
};
